export const IZIN_MAP = {
  CPIB: "032000000034",
  CBIB: "032000000068",
  CPPIB: "032000000014",
  CPOIB: "032000000019",
  CDOIB: "032000000036",
  KAPAL: "032000000033",
};